import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import { useGetMeApi } from "../services/apis/user.api";

import defineAbilityUser, { AbilityContext } from "../services/ability.service";
import { useRootSelector } from "../stores/reducers/root";
import { useMemo } from "react";
import useScript from "../hook/useScript";

const MainLayout = () => {
  const { profile } = useGetMeApi();

  const user = useRootSelector((state) => state.user.userProfile);
  const ability = useMemo(() => defineAbilityUser(user), [user]);

  // Load Pancake chat plugin script using custom hook
  useScript(
    "https://chat-plugin.pancake.vn/main/auto?page_id=web_Shotpik",
    "pancake-chat-script",
    {
      onLoad: () => console.log("Pancake chat script loaded successfully"),
      onError: (error) => console.error("Failed to load Pancake chat script:", error)
    }
  );

  return (
    <AbilityContext.Provider value={ability}>
      <Header user={profile} />
      <div className="max-w-[1440px] m-auto min-h-screen">
        <Outlet />
      </div>
    </AbilityContext.Provider>
  );
};

export default MainLayout;
